export default __webpack_public_path__ + "static/redbull-a2891714309322e4ff295fd39ee10c3c.svg";